import classes from "./primaryButton.module.css";
import { ButtonHTMLAttributes } from "react";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "light" | "dark" | "active";
  size?: "normal" | "small";
  leftIconUrl?: string;
  fullWidth?: boolean;
}

const PrimaryButton = (props: IProps) => {
  const {
    variant = "active",
    size = "normal",
    fullWidth = false,
    leftIconUrl,
    children,
    ...buttonProps
  } = props;

  const classNames = [
    classes.btn,
    variant === "active" ? classes.active : variant === "light" ? classes.light : classes.dark,
    size === "normal" ? classes.normal : classes.small,
  ];

  if (fullWidth) {
    classNames.push(classes.fullWidth);
  }

  if (!children) {
    classNames.push(classes.withoutChildren);
  }

  return (
    <button className={classNames.join(" ")} {...buttonProps}>
      <div className={classes.background}>
        <div className={classes.wrapper}>
          { leftIconUrl && (
            <img className={classes.icon} src={leftIconUrl} alt="button icon"/>
          )}
          {
            children && (<div>{ children }</div>)
          }
        </div>
      </div>
    </button>
  );
};

export default PrimaryButton;
